import { render, staticRenderFns } from "./TourNovidades.vue?vue&type=template&id=95b3fd92&"
import script from "./TourNovidades.vue?vue&type=script&lang=js&"
export * from "./TourNovidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports